/* @flow */
import {get, isEqual} from 'lodash';

import {trigger as triggerEdap} from '../utils/edapWrapper';
import type {Store} from '../reducers/index';

// We want to ignore some changes in our search query param compare.
const queryParamsMask = {
    neLat: 0,
    neLong: 0,
    swLat: 0,
    swLong: 0,
    zoom: 0,
    include: [],
    ssr: false
};
const getQueryParams = (data: Object) =>
    get(data, 'payload.variables.params', {});
const objEqual = (a: Object, b: Object) => {
    for (const key in a) {
        if (!isEqual(a[key], b[key])) {
            return false;
        }
    }
    return true;
};
let lastQueryParams = {};

// Since the first query is executed server-side this is used to set the parameters that were used once the page gets to the browser.
export const setInitialSearchParams = (queryParams: Object) => {
    lastQueryParams = {...queryParams, ...queryParamsMask};
};

export const triggerSearchEdap = (store: Store, data: Object) => {
    const currentQueryParams = {...getQueryParams(data), ...queryParamsMask};

    // Per TRAVBUGS-62 fire the EDAP search events anytime the query params change except map coordinate changes.
    if (objEqual(currentQueryParams, lastQueryParams)) {
        return;
    }

    lastQueryParams = currentQueryParams;

    const {arrival, departure} = currentQueryParams;
    if (arrival && departure) {
        triggerEdap('dated.search.submit');
    } else {
        triggerEdap('search.submit');
    }
    triggerEdap('search_query.submitted', {
        action_location: 'search'
    });
};
